import Accordion from '@base/components/src/Accordion';
import Image from '@base/components/src/Image';
import { ProductConditionRank } from '@package/core/src/shoppingCart/types';
import clsx from 'clsx';
import config from 'config-base';

import ProductCardName from '@/components/ProductCardName';
import ProductDescription from '../ProductDescription';

import styles from './ProductInfo.module.css';
import { ProductInfoProps } from './types';

const ProductInfo = (props: ProductInfoProps) => {
  const { product, productTextClassName, layout, isReviewOrderPage, isShippingOptionPage } = props;
  const productIDDescription = config.brandCode === '2' ? product.brandItemCode : product.id;
  const renderProductWithDescription = (productTypeService: boolean) =>
    !productTypeService ? (
      <>
        <Accordion
          title={
            <p data-testid="product-sku" className={`${styles.productBoldText} productBoldText`}>
              {!product.itemConditionRank && (
                <span
                  className={clsx(styles.productId, productTextClassName, {
                    [styles.orderDetailsProductId]: layout === 'order-details',
                    [styles.orderDetailsReviewProductId]: isReviewOrderPage,
                  })}
                >
                  {productIDDescription}
                </span>
              )}
              {product.itemConditionRank && (
                <span
                  data-testid="item-condition-rank"
                  className={clsx(
                    styles.productConditionRank,
                    styles.productConditionRankAccordion,
                    productTextClassName,
                  )}
                >
                  {ProductConditionRank[product.itemConditionRank]}
                </span>
              )}
              <span data-testid="product-sku-icon" className={styles.infoIconWrapper}>
                <Image
                  src="/marketplace-static/images/icons/infoIcon.svg"
                  alt="info icon"
                  width={10}
                  height={10}
                  className={`${styles.infoIcon} infoIcon`}
                />
              </span>
            </p>
          }
          withoutIcon
          className={styles.accordionProductDesc}
          headerClassName={styles.accordionProductDescTitle}
          contentClassName={styles.accordionProductDescContent}
        >
          <ProductDescription
            description={product.productSpecifications}
            brandItemCode={productIDDescription ?? ''}
            layout={layout}
            isReviewOrderPage={isReviewOrderPage}
            isShippingOptionPage={isShippingOptionPage}
          />
        </Accordion>
        <div className={styles.productDescriptionDesktop}>
          <ProductDescription
            description={product.productSpecifications}
            brandItemCode={productIDDescription ?? ''}
            layout={layout}
            isReviewOrderPage={isReviewOrderPage}
            isShippingOptionPage={isShippingOptionPage}
          />
        </div>
      </>
    ) : (
      <>
        <ProductDescription
          description={product.productSpecifications}
          brandItemCode={productIDDescription ?? ''}
          layout={layout}
          isReviewOrderPage={isReviewOrderPage}
          isShippingOptionPage={isShippingOptionPage}
        />
        {product.itemConditionRank && (
          <span
            data-testid="product-condition-rank"
            className={clsx(styles.productConditionRank, styles.productConditionRankDescription)}
          >
            {ProductConditionRank[product.itemConditionRank]}
          </span>
        )}
      </>
    );

  return (
    <>
      <ProductCardName
        product={product}
        layout={layout}
        isReviewOrderPage={isReviewOrderPage}
        isShippingOptionPage={isShippingOptionPage}
      />
      {!product.superConfigurator &&
        !isShippingOptionPage &&
        (product.productSpecifications ? (
          renderProductWithDescription(product.typeService)
        ) : (
          <div data-testid="product-sku" className={`${styles.productBoldText} productBoldText`}>
            <span
              className={clsx(styles.productId, {
                [styles.orderDetailsProductId]: layout === 'order-details',
                [styles.orderDetailsReviewProductId]: isReviewOrderPage,
              })}
            >
              {productIDDescription}
            </span>
            {product.itemConditionRank && (
              <span className={styles.productConditionRank}>{ProductConditionRank[product.itemConditionRank]}</span>
            )}
          </div>
        ))}
    </>
  );
};

export default ProductInfo;
